module.exports = __webpack_public_path__ + "media/images/tienda-2-da4130891c1251b9ce09c60bb5f28db6.jpg";